import { useFormik } from 'formik';
// mantine
import { Button, UnstyledButton } from '@mantine/core';
// components
import { TPersona } from '@newo/api/gateway';
import PersonasAutocomplete from '@/modules/Personas/components/PersonasAutocomplete';
// utils
import { IChatPersona } from '@/modules/Chat/Chat.types.ts';
import validationSchema from '@/modules/Sandbox/components/SelectActorForm/SelectActorForm.schema.ts';

interface SelectPersonaFormProps {
    isAgent?: boolean;
    persona?: IChatPersona;
    onClose: () => void;
    onSubmit: (persona?: IChatPersona) => void;
}

const SelectPersonaForm = ({
    isAgent = false,
    persona,
    onClose,
    onSubmit
}: SelectPersonaFormProps) => {
    const formik = useFormik({
        initialValues: {
            persona
        },
        validationSchema,
        onSubmit(values) {
            onSubmit(values.persona);
            onClose();
        }
    });

    const handleCancel = () => {
        onClose();
    };

    const handleSelect = async (p?: TPersona) => {
        if (p) {
            const { id, name } = p;
            await formik.setFieldValue('persona', { id, name });
        } else {
            await formik.setFieldValue('persona', undefined);
        }
    };

    return (
        <form
            autoComplete="off"
            className="flex flex-col gap-3"
            onSubmit={formik.handleSubmit}
        >
            <PersonasAutocomplete
                label="Select Personas"
                params={{ is_linked_to_agent: isAgent }}
                personaName={persona?.name}
                placeholder="Start typing..."
                onSelectAsync={handleSelect}
            />
            <div className="flex justify-between gap-2">
                <UnstyledButton
                    className="text-xs text-gray-6"
                    onClick={handleCancel}
                >
                    Cancel
                </UnstyledButton>
                <Button
                    disabled={
                        !formik.dirty || !formik.isValid || formik.isSubmitting
                    }
                    size="xs"
                    type="submit"
                >
                    Save
                </Button>
            </div>
        </form>
    );
};

export default SelectPersonaForm;
